import * as React from 'react';
import {connect} from 'react-redux';
import {DropdownButton, MenuItem} from 'react-bootstrap';
import {Subheading} from './subheading';
import {
    TEXT_ERROR_NO_READINGS, TEXT_TOOLTIP_VIEW_ALARMS,
    TEXT_CONFIGURATION, TEXT_TOOLTIP_REMOVE_FROM_DASHBOARD,
    TEXT_TOOLTIP_ADD_TO_DASHBOARD, TEXT_TOOLTIP_SUBSCRIBE, TEXT_SUBSCRIBE,
    TEXT_UNSUBSCRIBE, TEXT_TOOLTOP_EDIT_UNIT, TEXT_OFFLINE, TEXT_DISABLED
} from '../model/locale';
import {
    getCabinetsData, getCabinetsDataById, getSensorsData, resetSensorStore,
    updateCabinetDashboardDisplay, updateCabinetSubscribeDisplay,
    updateSensorList
} from "../model/cabinets";
import moment from 'moment';
import * as _ from 'underscore';
import {createMergeAction, SiteSettings} from "../model/base";
import {DateRangePickerWithLive, EditUnitModal, SubscribeModal} from "./modals";
import {LineChartWithLegend} from "./charts";
import {routeActions} from "redux-simple-router";
import {Link} from 'react-router';
import {IconButton} from "./iconbutton";
import {appRoutes} from "../model/routes/main";
import {dashboardAddButtonClass, subscribeButtonClass} from "./cabinetlist";
import {setContactModalValidationErrors, updateUserSettings} from "../model/account";

export enum ChartMode {
    Live = 0, Today = 1, Other = 2
}

export interface CabinetDetailsProps {
    unitId: string;
    location?: any;
    dispatch?: Function;
    textForKey?: Function;
    params?: any;
    sensors?: any;
    data?: any;
    ui?: any;
    user?: any;
    liveData?: any;
}

export class CabinetDetails extends React.Component<CabinetDetailsProps, any> {
    state: {
      showLoading: boolean;
      isLive: boolean;
      selectedIds: any;
      showEdit: boolean;
      showContact: boolean;
    };

    constructor(props) {
        super();
        this.state = {
            showLoading: false,
            isLive: !(props.location.query.chartMode === ChartMode.Other),
            selectedIds: [0],
            showContact: false,
            showEdit: false
        };
    }

    buildChartProps(unitId, sensors) {
        let {textForKey} = this.props;
        if (sensors[unitId]) {
            let colors = ["#0086d0", "#e57d8e", "#61dba3", "#efcd4a", "#c1c0c0"],
                colorNames = ["blue", "red", "green", "yellow", "grey"],
                series = [],
                details: any;
            if (this.props.data.units.count <= 0 ) return;
            details = this.props.data.units.results[0];
            let seriesObj = {};
            _.map(sensors[unitId].readings, (readingObj: any) => {
                // filter things out into series
                let timestamp = readingObj.timestamp * 1000;
                let readings = readingObj.localized_readings || {};
                for (let key of Object.keys(readings)) {
                    seriesObj[key] ?
                        seriesObj[key].push([timestamp, parseInt(readings[key], 10)]) :
                        seriesObj[key] = [[timestamp, parseInt(readings[key], 10)]];
                }
            });
            let colorIndex = 0;
            for (let i of Object.keys(details.sensors || {})) {
                let sensorData = details.sensors[i];
                if (sensorData.visible) {
                    let data = seriesObj[sensorData.key] || [],
                        contains = _.contains(this.state.selectedIds, colorIndex);
                    series.push({
                        sensor: sensorData,
                        selected: contains,
                        visible: contains,
                        color: colors[colorIndex % colors.length],
                        data: data,
                        name: sensorData.sensor_description,
                        colorClass: colorNames[colorIndex % colors.length],
                        tooltip: {
                            valueSuffix: sensorData.unit_of_measurement.um_abbreviated
                        },
                        yAxis: sensorData.unit_of_measurement.um_variable || sensorData.unit_of_measurement.um_full,
                        legendIndex: colorIndex++
                    });
                }
            }
            return {series, details, textForKey};
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if (!nextProps.sensors[this.props.params.unitId]) {
            let unitId = nextProps.params.unitId;
            let now = moment();
            let to = nextState.isLive ? moment().unix() : nextProps.location.query.to;
            let from = nextState.isLive ? now.subtract(4, 'hours').unix() : nextProps.location.query.from;
            this.props.dispatch(getCabinetsDataById(unitId));
            this.props.dispatch(getSensorsData({
                unit_id: unitId,
                forDetails: true,
                live: this.state.isLive,
                options: {
                    from: from,
                    to: to,
                    langcode: this.props.data.user.language
                }
            }));
            if (!nextState.isLive) this.clearTimer(this.props.ui);
            nextProps.sensors[unitId] = {};
        }
        if (nextState.isLive && !(nextProps.ui.timers.id)) {
            this.startTimer(this.props.ui, this.state.isLive);
        }
        if (!nextProps.ui.premisesUnits.loading
                && nextProps.data.premisesUnits.length === 0
                && nextProps.data.units.count === 1
                && nextProps.data.units.results[0].gateway.premises.slug) {
            this.props.dispatch(getCabinetsData(
                {
                    gateway__premises__slug: this.props.data.units.results[0].gateway.premises.slug
                },
                updateSensorList,
                true
            ));
        }

    }

    startTimer(ui, live) {
        let timers = ui.timers;
        if (timers && !timers.id) {
            let timer = setTimeout(
                function (arg) {
                    let unitId = arg.props.params.unitId;
                    let readings = arg.props.data.sensors[unitId].readings,
                        now = moment();
                    arg.props.dispatch(getSensorsData({
                        unit_id: unitId,
                        forDetails: true,
                        live: live,
                        options: {
                            from: readings && readings[readings.length - 1] ?
                                readings[readings.length - 1].timestamp :
                                now.subtract(4, 'hours').unix(),
                            to: now.unix(),
                            langcode: arg.props.data.user.language
                        }
                    }));
                    arg.props.dispatch(createMergeAction(
                        'stop_timer',
                        {ui: {timers: {id: 0}}}
                    ));
                },
                SiteSettings.readingsPollDelay,
                this
            );
            this.props.dispatch(createMergeAction(
                'start_timer',
                {ui: {timers: {id: timer}}}
            ));
        }
    }

    clearTimer(ui) {
        if (ui.timers.id) {
            clearTimeout(ui.timers.id);
            this.props.dispatch(createMergeAction(
                'stop_timer',
                {ui: {timers: {id: 0}}}
            ));
        }
    }

    componentDidUpdate() {
        let chart = (this.refs.chart as any);
        if (chart) {
            if (_.some(chart.chart.series, (s: any) => s.data.length > 0)) {
                chart.chart.hideLoading();
                return;
            }
            chart.chart.showLoading(this.props.textForKey(TEXT_ERROR_NO_READINGS));
        }
    }

    formChanged(currentValues, unitId) {
        let {dispatch} = this.props;
        dispatch(resetSensorStore());
        dispatch(routeActions.push("/cabinet-details/" + unitId));
    }

    buildSelect() {
        let {data} = this.props;
        let title = data.units.results[0].description || data.units.results[0].unit_id ;
        let options = data.premisesUnits.map(function (unit) {
            return <MenuItem eventKey={unit.unit_id} className="dropdown-item">
                {unit.description ? unit.description : unit.unit_id}
            </MenuItem>;
        });
        return <DropdownButton id="cabinet-selector" className="cabinet-selector dropdown"
                         onSelect={this.formChanged.bind(this)}
                         title={title}
                         key={data.units.results[0].unit_id}>
                        {options}
                    </DropdownButton>;
    }

    getStoreLink(cabinetDesc) {
        if (cabinetDesc) {
            let linkParams = {
                activeClassName: 'active',
                className: `link-stores`,
                to: 'cabinets?store_slug=' + cabinetDesc.gateway.premises.slug
            };
            return <Link {...linkParams}>{cabinetDesc.gateway.premises.name || ""}</Link>;
        }
    }

    openEdit() {
        this.setState({showEdit: true});
    }

    closeEdit() {
        this.setState({showEdit: false});
    }

    openContactDetails() {
        this.setState({ showContact: true, showExport: false });
    }

    closeContactDetails() {
        this.setState({ showContact: false, showExport: false });
    }

    updateUserAction (cabinet, data: any) {
        this.props.dispatch(updateUserSettings(data)).then(() => {
            this.closeContactDetails();
            this.props.dispatch(updateCabinetSubscribeDisplay(cabinet.unit_id, !cabinet.subscribed));
        }).catch(error => {
            this.props.dispatch(setContactModalValidationErrors(null));
            if (!_.isEmpty(error.data)) {
                this.props.dispatch(setContactModalValidationErrors(error.data));
            }
        });
    }

    subscribeAction(cabinet, user) {
        // if saved details
        if (!cabinet.subscribed && user.email.length === 0 && user.mobile.length === 0) {
            // do modal popup
            this.openContactDetails();
        } else {
            this.props.dispatch(updateCabinetSubscribeDisplay(cabinet.unit_id, !cabinet.subscribed));
        }
    }

    render() {
        let {sensors, params, ui, textForKey, data} = this.props;
        let onChartModeChange = this.onChartModeChange.bind(this);
        let cabinetDesc: any = this.props.data.units.count > 0 ?
            _.findWhere(this.props.data.units.results, {unit_id: params.unitId}) :
            null;
        let loading = null;

        let configureAttrs = {
            className: 'btn-configure',
            tooltip: this.props.textForKey(TEXT_CONFIGURATION),
            onClick: null,
        };

        if (ui.premisesUnits.loading || ui.sensors.readingsLoading) {
            loading = <div className="loader"/>;
        }
        let title = null;
        if (data.premisesUnits.length > 1) {
            title = this.buildSelect();
        } else {
            title = <div className="single-cabinet">
                {cabinetDesc ? cabinetDesc.description || cabinetDesc.unit_id : ''}
            </div>;
        }
        title = <div className="storeName">
            {this.getStoreLink(cabinetDesc)}&nbsp;<div className="non-mobile-info"/>&nbsp;
            {title}
        </div>;
        let body, cabinetHead, cabinetOptions, offline;
        if (!(loading)) {
            let lineChartProps = this.buildChartProps(params.unitId, sensors);
            body = <LineChartWithLegend {...lineChartProps}/>;
        } else {
            body = loading;
        }
        let alarmBtnClass = 'btn-alarm';
        if (cabinetDesc) {
            if (cabinetDesc.uncleared_alarms > 0) {
                alarmBtnClass += ' activated';
            }

            let editUnitAttrs = {
                className: 'edit-unit-btn',
                tooltip: this.props.textForKey(TEXT_TOOLTOP_EDIT_UNIT),
                onClick: this.openEdit.bind(this)
            };
            let editUnitProps = {
                textForKey: this.props.textForKey,
                state: {
                    show: this.state.showEdit,
                    onHide: this.closeEdit.bind(this)
                },
                onSubmit: () => null,
                unitName: cabinetDesc.description,
                unitModel: cabinetDesc.makemodel ? cabinetDesc.makemodel.model : null,
                unitMake: cabinetDesc.makemodel ? cabinetDesc.makemodel.make.make : null,
                maxValue: null, // TODO: Find out what these are...
                minValue: null,
                unitOfMeasurement: null,
                limitLines: false
            };
            let dashboardTextKey = cabinetDesc.dashboard_display ?
                TEXT_TOOLTIP_REMOVE_FROM_DASHBOARD :
                TEXT_TOOLTIP_ADD_TO_DASHBOARD;
            let dashboardAttrs = {
                className: dashboardAddButtonClass(ui.cabinets, cabinetDesc),
                tooltip: this.props.textForKey(dashboardTextKey),
                onClick: () => {
                    this.props.dispatch(updateCabinetDashboardDisplay(
                        cabinetDesc.unit_id, !cabinetDesc.dashboard_display
                    ));
                },
                activated: cabinetDesc.dashboard_display,
                disabled: ui.cabinets[cabinetDesc.unit_id] ?
                    ui.cabinets[cabinetDesc.unit_id].settingDashboardDisplay :
                    false,
            };
            let subscribeAttrs = {
                className: subscribeButtonClass(ui.cabinets, cabinetDesc),
                tooltip: this.props.textForKey(TEXT_TOOLTIP_SUBSCRIBE),
                onClick: (() => {
                    this.subscribeAction(cabinetDesc, this.props.data.user);
                }),
                dataItem: cabinetDesc,
                activated: cabinetDesc.subscribed,
                disabled: ui.cabinets[cabinetDesc.unit_id] ?
                    ui.cabinets[cabinetDesc.unit_id].isSubscribing : false
            };
            let subscribeProps = {
                state: {
                    show: this.state.showContact,
                    onHide: this.closeContactDetails.bind(this)
                },
                textForKey: this.props.textForKey,
                updateAction: ((updateData: any) =>
                    this.updateUserAction(cabinetDesc, updateData)),
                validationErrors: ui.contactModalValidationErrors
            };
            let cabinetOffline = cabinetDesc.unit_offline || !cabinetDesc.enabled ;
            let offlineClass = cabinetOffline ? "cabinet-offline" : "cabinet-offline-hide";
            offline = <div className={"row cabinetDetailsOffline offline-holder " + offlineClass}>
                {cabinetDesc.enabled ? textForKey(TEXT_OFFLINE) : textForKey(TEXT_DISABLED)}
            </div>;
            let unclearedLink = `${appRoutes.alarms.path}?store_slug=${cabinetDesc.gateway.premises.slug}&unit_id=${cabinetDesc.unit_id}`;
            cabinetHead = <div className="row cabinetLiveHead">
                <EditUnitModal {...editUnitProps}/>
                <SubscribeModal ref="subscribe" {...subscribeProps}/>
                <div className="pull-left">
                    {cabinetDesc.makemodel ? cabinetDesc.makemodel.make.make  + " - " + cabinetDesc.makemodel.model : ""}
                </div>
                <div className="pull-right">
                    <IconButton {...editUnitAttrs}/>

                    <IconButton href={`${appRoutes.alarmConfig.path}#?cabinet=${cabinetDesc.unit_id}`} {...configureAttrs}/>

                    <IconButton href={unclearedLink}
                                className={alarmBtnClass}
                                tooltip={this.props.textForKey(TEXT_TOOLTIP_VIEW_ALARMS)}>
                        {cabinetDesc.uncleared_alarms}
                    </IconButton>
                </div>
            </div>;
            cabinetOptions = <div className="row cabientOptions">
                <div className="bottom-info-holder pull-left">
                    {cabinetDesc.gateway.premises.region.name ?
                        [cabinetDesc.gateway.premises.street_address + ",", <br />] :
                        cabinetDesc.gateway.premises.street_address}
                    {cabinetDesc.gateway.premises.region.name ?
                        cabinetDesc.gateway.premises.region.name : ""}
                </div>
                <div className="bottom-info-holder pull-right">
                    <div className="addToDashboard">
                        <IconButton {...dashboardAttrs}>
                            {textForKey(dashboardTextKey)}
                        </IconButton>
                    </div>
                    <div className="subscribe">
                        {textForKey( cabinetDesc.subscribed ? TEXT_UNSUBSCRIBE : TEXT_SUBSCRIBE )}
                        <br />
                        <IconButton {...subscribeAttrs}/>
                    </div>
                </div>
            </div>;

        }
        return (
            <div className="container content cabinetDetails">
                <Subheading title={title}>
                    <ChartModeSwitcher
                        chartMode={this.getChartMode(ChartMode.Live)}
                        onChange={onChartModeChange}
                        textForKey={textForKey}
                        location={this.props.location}
                        dispatch={this.props.dispatch}/>
                </Subheading>
                {cabinetHead}
                {offline}
                {body}
                {cabinetOptions}
            </div>
        );
    }

    private getChartMode(defaultChartMode: ChartMode) {
        let {chartMode} = this.props.location.query;
        return chartMode ? parseInt(chartMode, 10) : defaultChartMode;
    }

    private onChartModeChange(chartMode: ChartMode, from = null, to = null) {
        let {dispatch, location} = this.props;
        let q = null,
            isLive = true;
        if ((from && to) && ((to - from) > 0)) {
            q = {chartMode, from , to};
            isLive = false;
        }
        if (!(q)) {
            q = {chartMode};
        }
        let nextLocation = Object.assign({}, location, {query: q});
        delete nextLocation.search;
        this.setState({isLive: isLive});
        dispatch(routeActions.replace(nextLocation));
        dispatch(resetSensorStore());
    }
}

export interface ChartModeSwitcherProps {
    chartMode: ChartMode;
    onChange: (mode: ChartMode, date1?: any, date2?: any) => any;
    textForKey: Function;
    location?: any;
    dispatch?: any;
}

export class ChartModeSwitcher extends React.Component<ChartModeSwitcherProps, any> {
    render() {
        let chartMode = this.props.chartMode,
            startDate = this.props.location.query.from || moment().subtract(4, "hours"),
            endDate = this.props.location.query.to || moment(),
            onDateChange = this.onDateChange.bind(this);

        return (
            <div className="graph-mode-control">
                <DateRangePickerWithLive textForKey={this.props.textForKey}
                                         onChange={onDateChange}
                                         startDate={startDate}
                                         endDate={endDate}
                                         isLive={chartMode === ChartMode.Live}
                />
            </div>
        );
    }

    private  onDateChange(from, to) {
        if ((to.diff(from, 'hours')) > 4) {
            this.props.onChange(ChartMode.Other, from.unix(), to.unix());
        } else {
            this.props.onChange(ChartMode.Live);
        }

    }
}

export let CabinetDetailsConnected = connect(state => ({
    ui: state.ui,
    contactModalValidationErrors: state.ui.accounts.contactModal.validationErrors,
    textForKey: state.data.textForKey,
    viewType: state.ui.premises.viewType,
    premisesUnits: state.data.premisesUnits,
    loading: state.ui.premisesUnits.loading || state.ui.geo.loading,
    user: state.data.user,
    data: state.data,
    units: state.data.units,
    sensors: state.data.sensors,
    location: state.routing.location
}))(CabinetDetails);
